import React from 'react'

const Why = () => {
  return (
    <section className="bg-gradient-to-r from-indigo-900 to-primary-dark text-white">
      <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:max-w-screen-2xl lg:px-8 space-y-4 w-full">
        <h3 className="text-3xl font-medium">Why Online</h3>
        <p className="text-base md:text-lg">
          We want you to be industry ready as future of Tech industry is remote,
          with more and more top tech companies globally are hiring remote
          engineers also, it saves you a lot of money
        </p>
      </div>
    </section>
  )
}

export default Why
